import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import BackToTop from "./BackToTop";

export default function SiteLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Header />
      <main className="flex-1">
        {isHome ? (
          <Outlet />
        ) : (
          <div className="pt-16 md:pt-20">
            <Outlet />
          </div>
        )}
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}